module.exports = __webpack_public_path__ + "static/media/hab7-2.820d69a2.jpg";